import { CircleAlertIcon, XIcon } from "@lucide/icons";

import { styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";
import { ButtonLink } from "simplydo/react/ui/button";
import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import {
  List,
  ListContent,
  ListDescription,
  ListHeader,
  ListItem,
} from "simplydo/react/ui/list";

import actions from "actions";
import { useAppDispatch, useAppSelector } from "store";

const SecurityRecommendationsContainer = styled.div`
  width: 100%;
  padding: 15px;
  border-radius: 5px !important;
  margin-bottom: 20px;
  box-shadow: 0.5px 0.5px 2.5px 1px #c0c0c0;
  h3 {
    color: black;
  }
`;

const SecurityRecommendations = () => {
  const user = useAppSelector((state) => state.user);
  const theme = useTheme();

  const dispatch = useAppDispatch();
  const onHidden = () => {
    dispatch(actions.user.hideSecurityRecommendations());
  };

  return (
    <>
      {user?.recommendTwoFactor && !user.hideSecurityRecommendations && (
        <SecurityRecommendationsContainer theme={theme}>
          <H3 style={{ marginBottom: 5 }}>
            Security recommendations
            <Icon
              icon={XIcon}
              style={{ cursor: "pointer", float: "right" }}
              onClick={onHidden}
            />
          </H3>
          <p>
            As an administrator it is important that your account is as secure
            as possible.
          </p>
          <List divided>
            <ListItem>
              <Icon icon={CircleAlertIcon} color="orange" />
              <ListContent>
                <ListHeader>Set-up two-factor authentication</ListHeader>
                <ListDescription>
                  Two factor authentication (2FA or MFA) adds an extra layer of
                  security to your account in case anyone else guesses your
                  password.
                  <br />
                  <ButtonLink
                    size="small"
                    style={{ marginTop: 5 }}
                    color="secondary"
                    to="preferences/password"
                  >
                    Set-up 2FA
                  </ButtonLink>
                </ListDescription>
              </ListContent>
            </ListItem>
          </List>
        </SecurityRecommendationsContainer>
      )}
    </>
  );
};

export default SecurityRecommendations;
